import React from 'react'
import { SIGN_IN } from '../constants/routes'
import { Link as RouterLink } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import makeStyles from '@material-ui/core/styles/makeStyles'
import LogoButton from '../elements/buttons/LogoButton'
import NutritionistImage from '../assets/nutritionist.svg'
import blueBlob from '../assets/blueBlob.svg'
import pinkBlob from '../assets/pinkBlob.svg'
import orangeBlob from '../assets/orangeBlob.svg'
import purpleBlob from '../assets/purpleBlob.svg'
import { PALE_PINK } from '../constants/colors'
import FlokaLogo from '../assets/Logo-floka.png'

const useStyles = makeStyles((theme) => ({
    grid: {
        // position:'fixed',
        backgroundColor:"#000",
        padding: '6vw 4vw',
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    img: {
        height: '70px',
        width: 'inherit',
        cursor:"pointer"
    },
    background: {
        margin: 0,
        backgroundColor: "#000",
        background: 
        `#000`,
        // `
        // url(${purpleBlob}) center -1400px / 1600px no-repeat fixed,
        // url(${blueBlob})  -300px 63vh / 1600px no-repeat fixed,
        // url(${pinkBlob}) right bottom / 1600px no-repeat fixed,
        // url(${orangeBlob}) left center / 1600px no-repeat fixed`,
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '-1',
    },
    content: {
        // backdropFilter: 'blur(100px)',
        alignItems: 'center',
    },
    button: {
        marginTop:"70px",
        background: '#fff',
        maxWidth: '228px',
        height: '63px',
        fontFamily: 'Apercu Pro',
        fontWeight: 'bold',
        fontSize: '20px',
        textTransform: 'none',
        color: '#000',
        borderColor: '#526CF2',
        borderRadius: '0',
        '&:hover': {
            background: '#FFF',
            color: '#000',
        },
        margin: theme.spacing(4),
    },
    text:{
        color:"#fff",
        [theme.breakpoints.down(500)]: {
            marginLeft:"10px",
            marginRight:'10px'
        },
    },
    textBottom:{
        fontWeight:"normal",
        marginTop:"100px",
        color:"#fff",
        [theme.breakpoints.down(500)]: {
           marginLeft:"10px",
           marginRight:'10px'
        },
    },
    imgContainer:{
        marginTop:"50px"
    },
    imgContainer2:{
        marginTop:"50px",
        marginBottom:'60px'
    }
}))

function Error(props) {
    const classes = useStyles()

    if (props.isAuth) {
        return (
            <Grid
                container
                spacing={2}
                direction="column"
                justifyContent="center"
                className={classes.grid}
            >
                <Grid item>
                    <Typography
                        variant="h4"
                        className={classes.text}
                        align="center"
                        paragraph
                    >
                       Oops! The page is not found.
                    </Typography>
                    {/* <Typography variant="h4" color="textPrimary" align="center">
                        Click the button below and we'll get you right back to
                        healing clients faster.
                    </Typography> */}
                </Grid>
                <Grid item>
                    {/* <img
                        src={NutritionistImage}
                        className={classes.img}
                        alt="nutritionist-patient"
                    /> */}
                </Grid>
                <Button
                    component={RouterLink}
                    to={SIGN_IN}
                    fullWidth
                    className={classes.button}
                >
                    <b>Back</b>
                </Button>
                {/* <Grid item>
                    <LogoButton />
                </Grid> */}
                <Grid item>
                    <Typography
                        className={classes.textBottom}
                        variant="h6"
                        align="center"
                    >
                       Oops! There may be a typo in this URL- feel free to try again. 
                    </Typography>
                    {/* <Typography
                        variant="body2"
                        style={{ color: '#526CF2' }}
                    >
                        © 2022 CalendHer Technologies Corp
                    </Typography> */}
                </Grid>
                <Grid item className={classes.imgContainer2}>
                    <img
                        src={FlokaLogo}
                        className={classes.img}
                        alt="Floka Logo"
                        onClick={()=>{
                            window.open('https://www.floka.co/')
                        }}
                    />
                </Grid>
            </Grid>
        )
    } else {
        return (
            <Grid container className={classes.background}>
                <Grid
                    container
                    spacing={4}
                    direction="column"
                    justifyContent="center"
                    className={classes.content}
                >
                    <Grid item>
                        <Typography
                            className={classes.text}
                            variant="h3"
                            align="center"
                        >
                           Oops! Let's log you back in.
                        </Typography>
                        {/* <Typography
                            variant="h4"
                            color="textPrimary"
                            align="center"
                            style={{ padding: '20px' }}
                        >
                            Click the button below and we'll get you right back
                            to healing patients faster.
                        </Typography> */}
                    </Grid>
                    {/* <Grid item>
                        <img
                            src={NutritionistImage}
                            className={classes.img}
                            alt="nutritionist-patient"
                        />
                    </Grid> */}
                    <Button
                        component={RouterLink}
                        to={SIGN_IN}
                        fullWidth
                        className={classes.button}
                    >
                        <b>Login</b>
                    </Button>
                    {/* <Grid item>
                        <LogoButton />
                    </Grid> */}
                    <Grid item>
                        <Typography
                            className={classes.textBottom}
                            variant="h6"
                            align="center"
                        >
                           Tap the button above and we'll 
                           get you right back to healing faster. 
                        </Typography>
                        {/* <Typography
                            variant="body2"
                            style={{ color: '#526CF2' }}
                        >
                            © 2022 CalendHer Technologies Corp
                        </Typography> */}
                    </Grid>

                    <Grid item className={classes.imgContainer}>
                        <img
                            src={FlokaLogo}
                            className={classes.img}
                            alt="Floka Logo"
                            onClick={()=>{
                                window.open('https://www.floka.co/')
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default Error
